export default "__VITE_ASSET__BEYqgtNH__"